var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92 40.8V20.46H11.52V40.8H7.92ZM22.44 40.8V20.46H26.04V40.8H22.44ZM0 48V44.4H48V48H0ZM36.48 40.8V20.46H40.08V40.8H36.48ZM0 16.86V13.68L24 0L48 13.68V16.86H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAccounts);
export default __webpack_public_path__ + "static/media/whiteAccounts.8de5bc549cb08542b959cf6d0e11e06c.svg";
export { ForwardRef as ReactComponent };